/* React */
import React from 'react';

/* Assets */
import ExemploUmDark from '../../assets/exemplo_1_dark.png';
import ExemploUmSoft from '../../assets/exemplo_1_soft.png';
import ExemploDoisDark from '../../assets/exemplo_2_dark.png';
import ExemploDoisSoft from '../../assets/exemplo_2_soft.png';
import ExemploTresDark from '../../assets/exemplo_3_dark.png';
import ExemploTresSoft from '../../assets/exemplo_3_soft.png';
import ExemploQuatroDark from '../../assets/exemplo_4_dark.png';
import ExemploQuatroSoft from '../../assets/exemplo_4_soft.png';

/* Icons */
import { IoCloseOutline } from 'react-icons/io5';

/* Hooks */
import { useWordle } from '../../../WordleContext';

/* Styles */
import { Divisor, ModalExplanatory } from './styles';

interface Props {
  isVisible: boolean
}

export const Rules: React.FC<Props> = ({ isVisible }: Props) => {

  /* Context */
  const {
    setOpenModalExplanatory
  } = useWordle();

  return (
    <ModalExplanatory isVisible={isVisible ? true : false}>
      <main>
        <div>
          <h1>Como jogar</h1>
          <button onClick={() => setOpenModalExplanatory(false)}><IoCloseOutline /></button>
        </div>
        <Divisor />
        <p>Advinhe a palavra em 6 tentativas!</p>
        <p>Cada tentativa deve ser uma palavra de 5 letras válida.</p>
        <p>Aperte o botão "ENTER" para fazer uma tentativa.</p>
        <p>Após cada tentativa, a cor dos blocos irá mudar para mostrar quão perto você está de descobrir a palavra correta.</p>
        <Divisor />
        <span>Exemplos:</span>
        <section>
          {
            localStorage.getItem('@portalRecreativa:theme') === 'dark'
              ? <img src={ExemploUmDark} alt="Imagem de um exemplo de uma linha com a palavra PISTA,
               onde apenas a letra A está com o fundo verde, indicando que está correta" />
              : <img src={ExemploUmSoft} alt="Imagem de um exemplo de uma linha com a palavra PISTA,
              onde apenas a letra A está com o fundo verde, indicando que está correta" />
          }
          <p>Neste caso, a letra<span> A </span>está na palavra correta<span> e </span>na posição correta.</p>
          {
            localStorage.getItem('@portalRecreativa:theme') === 'dark'
              ? <img src={ExemploDoisDark} alt="Imagem de um exemplo de uma linha com a palavra PUNHO,
               onde apenas a letra O está com o fundo amarelo, indicando que está presente na palavra,
               mas não na posição correta" />
              : <img src={ExemploDoisSoft} alt="Imagem de um exemplo de uma linha com a palavra PUNHO,
              onde apenas a letra O está com o fundo amarelo, indicando que está presente na palavra,
              mas não na posição correta" />
          }
          <p>Já neste, a letra<span> O </span>está na palavra correta mas <span>não</span> na posição correta.</p>
          {
            localStorage.getItem('@portalRecreativa:theme') === 'dark'
              ? <img src={ExemploTresDark} alt="Imagem de um exemplo de uma linha com a palavra BORDA,
               onde as letras O,R,D e A estão com o fundo verde, indicando que estão corretas, e a letra B
               com o fundo cinza, indicando que está errada" />
              : <img src={ExemploTresSoft} alt="Imagem de um exemplo de uma linha com a palavra BORDA,
              onde as letras O,R,D e A estão com o fundo verde, indicando que estão corretas, e a letra B
              com o fundo cinza, indicando que está errada" />
          }
          <p>E o último caso, a letra<span> B não </span>está na palavra correta em <span>qualquer</span> posição.</p>
          <Divisor />
          <span>Perguntas frequentes:</span>
          <span>1. Existem palavras acentuadas?</span>
          <p>Sim! Para isso, basta escrevê-las sem acentuação, como visto na imagem a baixo, da qual
            a intentação era escrever a palavra "HERÓI", mas é registrada apenas como "HEROI".
          </p>
          {
            localStorage.getItem('@portalRecreativa:theme') === 'dark'
              ? <img src={ExemploQuatroDark} alt="Imagem de um exemplo com a palavra HERÓI, porém 
              escrita sem o acento agudo na letra O" />
              : <img src={ExemploQuatroSoft} alt="Imagem de um exemplo com a palavra HERÓI, porém 
              escrita sem o acento agudo na letra O" />
          }
        </section>
        <Divisor />
        <span>Todo dia uma nova palavra estará disponível! Bom jogo!</span>
      </main>
    </ModalExplanatory>
  );
};
